import logging from '../logging';
import { EditorView, basicSetup } from "codemirror"
import { indentWithTab } from '@codemirror/commands';
import { json as jsonExtension } from "@codemirror/lang-json";
import { keymap } from '@codemirror/view';
import injectCSS from '../html/inject-css';

const log = logging('components');

/**
 * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/JSON/stringify#the_replacer_parameter
 */
function noDefaultsReplacer(key: string, value: any) {
    const type = typeof value;
    switch(type) {
        case 'number':
        case 'string':
        case 'boolean':
            return value;
    }
    if(Array.isArray(value) && value.length == 0) {
        return undefined;
    }
    if(key == 'position' || key == 'rotation') {
        let { x, y, z } = value;
        if(x == 0) x = undefined;
        if(y == 0) y = undefined;
        if(z == 0) z = undefined;
        if(x == undefined && y == undefined && z == undefined) return undefined;
        return { x, y, z };
    }
    if(key == 'scale') {
        let { x, y, z } = value;
        if(x == 1) x = undefined;
        if(y == 1) y = undefined;
        if(z == 1) z = undefined;
        if(x == undefined && y == undefined && z == undefined) return undefined;
        return { x, y, z };
    }
    if(value == null) {
        return undefined;
    }

    return value;
}

const deleteNullsAndEmpties = (obj: unknown) => {
    if(typeof obj != 'object') return;

    for(const key of Object.keys(obj)) {
        if(typeof obj[key] != 'object') {
            continue;
        }

        if(obj[key] == null) {
            delete obj[key];
            continue;
        }

        const isArray = Array.isArray(obj[key]);
        if(isArray && obj[key].length == 0) {
            delete obj[key];
            continue;
        }
        if(isArray) {
            for(const item of obj[key]) {
                deleteNullsAndEmpties(item);
            }
            continue;
        }
        if(!isArray) {
            deleteNullsAndEmpties(obj[key]);
        }

        if(Object.keys(obj[key]).length == 0) {
            delete obj[key];
        }
    }
}


export default class JsonEditor extends HTMLElement {

    view: EditorView;

    constructor() {
        super();
        injectCSS(STYLESHEET);
    }

    connectedCallback() {
        this.view = new EditorView({
            extensions: [
                basicSetup,
                keymap.of([indentWithTab]),
                jsonExtension(),
            ],
            parent: this,
        });
    }

    setJSON(data: any) {
        if('toJSON' in data) {
            data = data.toJSON();
        }
        deleteNullsAndEmpties(data);
        this.view.dispatch({changes: {
          from: 0,
          to: this.view.state.doc.length,
          insert: JSON.stringify(data, noDefaultsReplacer, 4)
        }});
    }

    getDocumentText() {
        return this.view.state.doc.toString();
    }
}
window.customElements.define('json-editor', JsonEditor);
log.debug('Defined custom element <json-editor>');

const STYLESHEET = `
json-editor {
    & .cm-editor {
        width: 100%;
        height: 100%;
        left: 0; right: 0; top: 0; bottom: 0;
    }
}`;
